import React from 'react';
import './PeriodSelector.css';

const PERIOD_OPTIONS = [
  { id: 'current', label: 'Current Month', months: 1 },
  { id: 'select', label: 'Select Month', months: null },
  { id: '12months', label: '12 Months Starting', months: 12 },
  { id: 'all', label: 'All Data', months: 0 }
];

const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear; y >= 2020; y--) {
    years.push(y);
  }
  return years;
};

const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
];

const PeriodSelector = ({ 
  selectedPeriod, 
  selectedYear, 
  selectedMonth,
  selected12Year,
  selected12Month,
  onPeriodChange, 
  onYearChange, 
  onMonthChange,
  on12YearChange,
  on12MonthChange,
  disabled = false 
}) => {
  return (
    <div className="period-selector">
      <div className="period-tabs">
        {PERIOD_OPTIONS.map(option => (
          <button
            key={option.id}
            className={`period-tab ${selectedPeriod === option.id ? 'active' : ''}`}
            onClick={() => onPeriodChange(option.id)}
            disabled={disabled}
          >
            {option.label}
          </button>
        ))}
        {selectedPeriod === 'select' && (
          <div className="month-selector">
            <select 
              value={selectedYear} 
              onChange={(e) => onYearChange(parseInt(e.target.value))} 
              disabled={disabled}
            >
              {generateYearOptions().map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <select 
              value={selectedMonth} 
              onChange={(e) => onMonthChange(parseInt(e.target.value))} 
              disabled={disabled}
            >
              {MONTH_OPTIONS.map(month => (
                <option key={month.value} value={month.value}>{month.label}</option>
              ))}
            </select>
          </div>
        )}
        {selectedPeriod === '12months' && (
          <div className="month-selector">
            <select 
              value={selected12Year} 
              onChange={(e) => on12YearChange(parseInt(e.target.value))} 
              disabled={disabled}
            >
              {generateYearOptions().map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <select 
              value={selected12Month} 
              onChange={(e) => on12MonthChange(parseInt(e.target.value))} 
              disabled={disabled}
            >
              {MONTH_OPTIONS.map(month => (
                <option key={month.value} value={month.value}>{month.label}</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export { PERIOD_OPTIONS, MONTH_OPTIONS, generateYearOptions };
export default PeriodSelector;
